export const checkSusceptibleWearingCasco = (pieza) => {
  // si no contiene palabra casco en nota pública
  if (!(pieza?.notapublica).includes('casco')) return false
  // si no es un MOTOR, CAJA CAMBIO, INYECTORES
  if (pieza?.tipo_pieza_id !== 406 && pieza?.tipo_pieza_id !== 55 && pieza?.tipo_pieza_id !== 400 && pieza?.tipo_pieza_id !== 401 && pieza?.tipo_pieza_id !== 1341) {
    return false
  }
  return true
}
